import React from "react";
import Banner from "../../components/Banner";
import Footer from "../../components/Footer";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Spinner from "../../components/Spinner";
import { Modal } from "../../components/Modal";
import {primaryLabelName, secondaryLabelName, uniqueIdentifier1Name, uniqueIdentifier2Name} from "../../utils/helper"

const API = localStorage.getItem("assethost");

export default class MyAnnouncement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      valid: false,
      msg: "",
      toastColor: "",
      announcements: [],
      currentPage: 0,
      totalPages: 1,
      pageSize: 10,

      announcementDetail: {},
      announcementId: undefined,
      readMore: false,

      // Announcement form fields
      showAddModal: false,
      showAddMissingModal: false,
      category: "",
      subcategory: "",
      startDate: "",
      endDate: "",
      daysDuration: "",
      assetName1: "",
      assetName2: "",
      uniqueIdentifier1: "",
      uniqueIdentifier2: "",
      type: "",
      detail: "",
      pictureFile: null,
      categories: [],
      subcategories: [],
      types: [],
      announcementStatuss: [],
      errors: {},
      announcementStatus: 'DRAFT',
      lawEnforcementProfileId: Number(sessionStorage.getItem("lawEnforcementProfileId"))?Number(sessionStorage.getItem("lawEnforcementProfileId")):0
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.validate = this.validate.bind(this);
    this.fetchAnnouncements = this.fetchAnnouncements.bind(this);
    this.fetchAnnouncementById = this.fetchAnnouncementById.bind(this);
    this.fetchDropdowns = this.fetchDropdowns.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
  }

  componentDidMount() {
    this.fetchDropdowns();
    this.fetchAnnouncements();
  }

  fetchDropdowns() {
     const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    axios
      .get(API + "/announcement/announcement-form-data", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const data = response.data || {};
        this.setState({
          categories: data.categoryList || [],
          types: data.announcementTypeList,
        });
      })
      .catch((error) => {
        console.error("Failed to load dropdowns:", error);
      });
    axios
      .get(API + "/announcement/getannouncementstatus", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const data = response.data || {};
        this.setState({
          announcementStatuss: data});
      })
      .catch((error) => {
        console.error("Failed to load dropdowns:", error);
      });
  }

  fetchAnnouncements( page = 0) {
     const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });
     let request = {};
    if (this.state.announcementStatus) {
      request.announcementStatus = this.state.announcementStatus;
    } else {
      request.announcementStatus = "DRAFT";
    }
    if (Number(sessionStorage.getItem("companyProfileId"))) {
      request.companyProfileId = sessionStorage.getItem("companyProfileId");
    }
    if (Number(sessionStorage.getItem("individualProfileId"))) {
      request.individualProfileId = sessionStorage.getItem("individualProfileId");
    }
    if (Number(sessionStorage.getItem("lawEnforcementProfileId"))) {
      request.lawEnforcementProfileId = sessionStorage.getItem("lawEnforcementProfileId");
    }
    axios
      .post(API + `/announcement/getmylist`, request, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          limit: this.state.pageSize,
          offset: page * this.state.pageSize,
        },
      })
      .then((response) => {
        let announcements = [];
        let totalPages = 1;
        if (Array.isArray(response.data)) {
          announcements = response.data;
          totalPages = Math.ceil(announcements.length / this.state.pageSize);
        } else if (
          response.data &&
          response.data.content &&
          Array.isArray(response.data.content)
        ) {
          announcements = response.data.content;
          totalPages = response.data.totalPages || 1;
        }
        this.setState({
          announcements,
          currentPage: page,
          totalPages,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          announcements: [],
          totalPages: 1,
          loading: false,
          msg:
            error?.response?.data?.message || "Failed to load announcements.",
          toastColor: "danger",
        });
      });
  }

  fetchAnnouncementById() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    axios
      .get(API + `/announcement/getbyid/${this.state.announcementId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        console.log("Announcement detail response:", response.data);
        this.setState({
          announcementDetail: response.data,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          announcementDetail: {},
          loading: false,
          msg:
            error?.response?.data?.message || "Failed to load announcements.",
          toastColor: "danger",
        });
      });
  }

  handleChange(e) {
    const { name, value } = e.target;

    if (name === "category") {
      const subcategories = this.state.categories.find(
        (cat) => Number(cat.id) === Number(value)
      ).subcategorys;
      this.setState(
        {
          category: value,
          subcategory: "",
          subcategories: subcategories,
        },
        this.validate
      );
    } else {
      this.setState({ [name]: value }, this.validate);
    }
    if (name === "subcategory") {
        const subcategory = this.state.subcategories.find(
          (sub) => Number(sub.id) === Number(value)
        );
        this.setState({ assetType: subcategory.assetType });
      }
  }

  handleFileChange(e) {
    const { name } = e.target;
    const file = e.target.files ? e.target.files[0] : null;
    this.setState({ [name]: file });
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (!s.category && !s.showAddMissingModal) {
      errors.category = "Category is required";
      valid = false;
    }
    if (!s.subcategory && !s.showAddMissingModal) {
      errors.subcategory = "Subcategory is required";
      valid = false;
    }
    if (!s.startDate) {
      errors.startDate = "Start date is required";
      valid = false;
    } else {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const start = new Date(s.startDate);

      if (start < today) {
        errors.startDate = "Start date cannot be in the past";
        valid = false;
      }
    }

    if (!s.endDate ) {
      errors.endDate = "End date is required";
      valid = false;
    } else {
      const start = new Date(s.startDate);
      const end = new Date(s.endDate);

      if (s.startDate && end <= start) {
        errors.endDate = "End date must be after start date";
        valid = false;
      }
    }
    // if (!s.daysDuration) {
    //   errors.daysDuration = "Duration (days) is required";
    //   valid = false;
    // }
    if ((!s.assetName1 || !s.assetName1.trim())  && !s.showAddMissingModal) {
      errors.assetName1 = primaryLabelName(s.assetType)+" is required";
      valid = false;
    }
    if ((!s.assetName2 || !s.assetName2.trim())  && !s.showAddMissingModal) {
      errors.assetName2 = secondaryLabelName(s.assetType)+" is required";
      valid = false;
    }
    if ((!s.uniqueIdentifier1 || !s.uniqueIdentifier1.trim())  && !s.showAddMissingModal) {
      errors.uniqueIdentifier1 = uniqueIdentifier1Name(s.assetType)+" is required";
      valid = false;
    }
    // if (!s.uniqueIdentifier2 || !s.uniqueIdentifier2.trim()) {
    //   errors.uniqueIdentifier2 = "Unique identifier 2 is required";
    //   valid = false;
    // }
    if (!s.type && !s.showAddMissingModal) {
      errors.type = "Type is required";
      valid = false;
    }
    if (!s.detail || !s.detail.trim()) {
      errors.detail = "Details are required";
      valid = false;
    }
   
    this.setState({ errors, valid });
    return valid;
  }

  handleSave(e) {
    e.preventDefault();
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }

    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    let request = new FormData();
    request.append(
      "startDate",
      new Date(this.state.startDate).toISOString().split("Z")[0]
    );
    request.append(
      "endDate",
      new Date(this.state.endDate).toISOString().split("Z")[0]
    );
    // request.append("daysDuration", this.state.daysDuration);
    request.append("detail", this.state.detail);
    if (this.state.pictureFile) {
      request.append("pictureFile", this.state.pictureFile);
    }
    if(!this.state.showAddMissingModal)
        {
        request.append("announcementType", this.state.type);
        request.append("subCategoryId", this.state.subcategory);
        request.append("assetName1", this.state.assetName1);
        request.append("assetName2", this.state.assetName2);
        request.append("uniqueIdentifier1", this.state.uniqueIdentifier1);
        request.append("uniqueIdentifier2", this.state.uniqueIdentifier2);
        const assetType = this.state.subcategories?.find(
          (sub) => Number(sub.id) === Number(this.state.subcategory)
        ).assetType;
        request.append("assetType", assetType);

        }
     else
        {
          request.append("announcementType", "MISSING_PERSON");
        }   
    request.append(
      "companyProfileId",
      Number(sessionStorage.getItem("companyProfileId"))
    );
    request.append(
      "individualProfileId",
      Number(sessionStorage.getItem("individualProfileId"))
    );
    request.append(
      "lawEnforcementProfileId",
      Number(sessionStorage.getItem("lawEnforcementProfileId"))
    );

    axios
      .post(API + "/announcement/save", request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            msg: response.data.message || "Announcement added successfully!",
            toastColor: "success",
            loading: false,
            showAddModal: false,
            showAddMissingModal: false,
            category: "",
            subcategory: "",
            startDate: "",
            endDate: "",
            type: "",
            assetName1: "",
            assetName2: "",
            uniqueIdentifier1: "",
            uniqueIdentifier2: "",
            detail: "",
            pictureFile: "",
            subcategories: [],
            valid: false,
            errors: {},
          });
          setTimeout(() => {
            this.fetchAnnouncements(token, this.state.currentPage);
          }, 2000);
        } else {
          this.setState({
            msg: response.data.message || "Failed to add announcement",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to add announcement. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-h-screen flex justify-between bg-white">
        <Sidebar />
        <div className="min-h-screen w-[85%] flex flex-col">
          <Banner title="Public Announcement" />
          {divMsg}
          <div className="w-full grow px-5 flex flex-col items-center justify-start">
           { /*
            <div className="col flex gap-4 mt-2 mb-4 w-full justify-start">
              <button
                className="btn btn-success"
                onClick={() => this.setState({ showAddModal: true, msg: "" })}
              >
                Add Announcement
              </button>
            </div> */}
            { s.lawEnforcementProfileId > 0 &&
            <div className="flex gap-4 mt-2 mb-4 w-full justify-start">
              <button
                className="btn btn-success"
                onClick={() => this.setState({ showAddMissingModal: true, msg: "" })}
              >
                Add Missing Person
              </button>
            </div>
              }
            <div className="flex gap-2 mb-2 w-full">
              <div className="input-group">
                <label className="input-group-text">Status</label>
                <select
                  name="announcementStatus"
                  className={`form-control`}
                  value={s.announcementStatus}
                  onChange={this.handleChange}
                  
                >
                  <option value="">Select</option>
                  {s.announcementStatuss.map((cat) => (
                    <option key={cat} value={cat}>
                      {cat}
                    </option>
                  ))}
                </select>
              
              </div>
              <div className="input-group"></div>
              <button
                className="btn btn-success text-nowrap !w-[23rem]"
               
                onClick={this.fetchAnnouncements}
              >
                Search
              </button>
            </div>
            <div className="w-full overflow-x-auto border">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Title
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                     Announcement Type
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Unique Identifier 1
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Unique Identifier 2
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200 overflow-y-auto">
                  {s.announcements.map((item) => (
                    <tr key={`record-${item.id}`} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.title}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.announcementType}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.uniqueIdentifier1}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.uniqueIdentifier2}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                         <button
                          className="text-blue-500 hover:text-blue-600 hover:underline italic"
                          onClick={() =>
                            this.setState(
                              {
                                announcementId: item.id,
                                readMore: true,
                              },
                              this.fetchAnnouncementById
                            )
                          }
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {s.announcements.length === 0 && (
                <div className="text-gray-500 text-center py-4">
                  No announcements records found.
                </div>
              )}
            </div>

            {s.totalPages > 1 && (
              <div className="flex justify-center items-center gap-2 mt-4">
                <button
                  className="btn btn-outline"
                  disabled={s.currentPage === 0}
                  onClick={() =>
                    this.fetchAnnouncements(
                      sessionStorage.getItem("token"),
                      s.currentPage - 1
                    )
                  }
                >
                  Previous
                </button>
                <span>
                  Page {s.currentPage + 1} of {s.totalPages}
                </span>
                <button
                  className="btn btn-outline"
                  disabled={s.currentPage + 1 >= s.totalPages}
                  onClick={() =>
                    this.fetchAnnouncements(
                      sessionStorage.getItem("token"),
                      s.currentPage + 1
                    )
                  }
                >
                  Next
                </button>
              </div>
            )}
          </div>
          <Footer />
        </div>

        {/* Add Announcement Modal */}
        {s.showAddModal && (
          <Modal
            title="Add Public Announcement"
            closeAction={() => this.setState({ showAddModal: false })}
            footerContent={
              <>
                {s.valid && (
                  <button
                    type="submit"
                    className="btn btn-success"
                    disabled={s.loading}
                    form="announcementForm"
                  >
                    Save
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() =>
                    this.setState({
                      showAddModal: false,
                      category: "",
                      subcategory: "",
                      startDate: "",
                      endDate: "",
                      type: "",
                      assetName1: "",
                      assetName2: "",
                      uniqueIdentifier1: "",
                      uniqueIdentifier2: "",
                      detail: "",
                      pictureFile: "",
                      subcategories: [],
                      valid: false,
                      errors: {},
                    })
                  }
                >
                  Close
                </button>
              </>
            }
          >
            <form
              id="announcementForm"
              onSubmit={this.handleSave}
              className="space-y-4"
              autoComplete="off"
            >
              {divMsg}
              <div className="grid grid-cols-2 gap-4">
                <div className="input-group">
                  <label className="input-group-text required">Category</label>
                  <select
                    name="category"
                    className={`form-control ${
                      s.errors.category ? " !border-red-500" : ""
                    }`}
                    value={s.category}
                    onChange={this.handleChange}
                    required
                  >
                    <option value="">Select</option>
                    {s.categories.map((cat) => (
                      <option key={`category-${cat.id}`} value={cat.id}>
                        {cat.name}
                      </option>
                    ))}
                  </select>
                  {s.errors.category && (
                    <span className="input-group-error">
                      {s.errors.category}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">Subcategory</label>
                  <select
                    name="subcategory"
                    className={`form-control ${
                      s.errors.subcategory ? " !border-red-500" : ""
                    }`}
                    value={s.subcategory}
                    onChange={this.handleChange}
                    required
                  >
                    <option value="">Select</option>
                    {s.subcategories?.map((subcat) => (
                      <option
                        key={`subcategory-${subcat.id}`}
                        value={subcat.id}
                      >
                        {subcat.name}
                      </option>
                    )) || []}
                  </select>
                  {s.errors.subcategory && (
                    <span className="input-group-error">
                      {s.errors.subcategory}
                    </span>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div className="input-group">
                  <label className="input-group-text">Start Date</label>
                  <input
                    name="startDate"
                    className={`form-control ${
                      s.errors.startDate ? " !border-red-500" : ""
                    }`}
                    type="date"
                    min={new Date().toISOString().split("T")[0]}
                    max={s.endDate || undefined}
                    value={s.startDate}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.startDate && (
                    <span className="input-group-error">
                      {s.errors.startDate}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">End Date</label>
                  <input
                    name="endDate"
                    className={`form-control ${
                      s.errors.endDate ? " !border-red-500" : ""
                    }`}
                    type="date"
                    min={s.startDate || new Date().toISOString().split("T")[0]}
                    value={s.endDate}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.endDate && (
                    <span className="input-group-error">
                      {s.errors.endDate}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">Type</label>
                  <select
                    name="type"
                    className={`form-control ${
                      s.errors.type ? " !border-red-500" : ""
                    }`}
                    value={s.type}
                    onChange={this.handleChange}
                    required
                  >
                    <option value="">Select</option>
                    {s.types.map((type) => (
                      <option key={`type-${type}`} value={type}>
                        {type.replace("_", " ")}
                      </option>
                    ))}
                  </select>
                  {s.errors.type && (
                    <span className="input-group-error">{s.errors.type}</span>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div className="input-group">
                  <label className="input-group-text">{primaryLabelName(s.assetType)}:</label>
                  <input
                    name="assetName1"
                    className={`form-control ${
                      s.errors.assetName1 ? " !border-red-500" : ""
                    }`}
                    type="text"
                    value={s.assetName1}
                    onChange={this.handleChange}
                    placeholder="Enter asset name 1 (e.g., Model)"
                    required
                  />
                  {s.errors.assetName1 && (
                    <span className="input-group-error">
                      {s.errors.assetName1}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">{secondaryLabelName(s.assetType)}:</label>
                  <input
                    name="assetName2"
                    className={`form-control ${
                      s.errors.assetName2 ? " !border-red-500" : ""
                    }`}
                    type="text"
                    value={s.assetName2}
                    onChange={this.handleChange}
                    placeholder="Enter asset name 2 (e.g., Brand)"
                    required
                  />
                  {s.errors.assetName2 && (
                    <span className="input-group-error">
                      {s.errors.assetName2}
                    </span>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div className="input-group">
                  <label className="input-group-text">
                   {uniqueIdentifier1Name(s.assetType)}:
                  </label>
                  <input
                    name="uniqueIdentifier1"
                    className={`form-control ${
                      s.errors.uniqueIdentifier1 ? " !border-red-500" : ""
                    }`}
                    type="text"
                    value={s.uniqueIdentifier1}
                    onChange={this.handleChange}
                    placeholder="Enter unique identifier 1 (e.g., Serial Number)"
                    required
                  />
                  {s.errors.uniqueIdentifier1 && (
                    <span className="input-group-error">
                      {s.errors.uniqueIdentifier1}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">
                    {uniqueIdentifier2Name(s.assetType)}
                  </label>
                  <input
                    name="uniqueIdentifier2"
                    className={`form-control ${
                      s.errors.uniqueIdentifier2 ? " !border-red-500" : ""
                    }`}
                    type="text"
                    value={s.uniqueIdentifier2}
                    onChange={this.handleChange}
                    placeholder="Enter unique identifier 2 (e.g., IMEI 2)"
                  />
                  {s.errors.uniqueIdentifier2 && (
                    <span className="input-group-error">
                      {s.errors.uniqueIdentifier2}
                    </span>
                  )}
                </div>
              </div>

              <div className="input-group">
                <label className="input-group-text">Details</label>
                <textarea
                  name="detail"
                  className={`form-control ${
                    s.errors.detail ? " !border-red-500" : ""
                  }`}
                  value={s.detail}
                  onChange={this.handleChange}
                  placeholder="Enter announcement detail"
                  rows="3"
                  required
                />
                {s.errors.detail && (
                  <span className="input-group-error">{s.errors.detail}</span>
                )}
              </div>
              <div className="row">
                <div className="col">
                  <div className="input-group">
                    <label className="input-group-text">Picture</label>
                    <input
                      name="pictureFile"
                      className="form-control"
                      type="file"
                      onChange={this.handleFileChange}
                      accept="image/*"
                    />
                    {s.errors.pictureFile && (
                      <span className="input-group-error">
                        {s.errors.pictureFile}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col"></div>
              </div>
            </form>
          </Modal>
        )}
          {/* Add Missing Modal */}
        {s.showAddMissingModal && (
          <Modal
            title="Add Missing Person Announcement"
            closeAction={() => this.setState({ showAddMissingModal: false })}
            footerContent={
              <>
                {s.valid && (
                  <button
                    type="submit"
                    className="btn btn-success"
                    disabled={s.loading}
                    form="announcementForm"
                  >
                    Save
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() =>
                    this.setState({
                      showAddMissingModal: false,
                      category: "",
                      subcategory: "",
                      startDate: "",
                      endDate: "",
                      type: "MISSING",
                      assetName1: "",
                      assetName2: "",
                      uniqueIdentifier1: "",
                      uniqueIdentifier2: "",
                      detail: "",
                      pictureFile: "",
                      subcategories: [],
                      valid: false,
                      errors: {},
                    })
                  }
                >
                  Close
                </button>
              </>
            }
          >
            <form
              id="announcementForm"
              onSubmit={this.handleSave}
              className="space-y-4"
              autoComplete="off"
            >
              {divMsg}

              <div className="grid grid-cols-2 gap-4">
                <div className="input-group">
                  <label className="input-group-text">Start Date</label>
                  <input
                    name="startDate"
                    className={`form-control ${
                      s.errors.startDate ? " !border-red-500" : ""
                    }`}
                    type="date"
                    min={new Date().toISOString().split("T")[0]}
                    max={s.endDate || undefined}
                    value={s.startDate}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.startDate && (
                    <span className="input-group-error">
                      {s.errors.startDate}
                    </span>
                  )}
                </div>
                <div className="input-group">
                  <label className="input-group-text">End Date</label>
                  <input
                    name="endDate"
                    className={`form-control ${
                      s.errors.endDate ? " !border-red-500" : ""
                    }`}
                    type="date"
                    min={s.startDate || new Date().toISOString().split("T")[0]}
                    value={s.endDate}
                    onChange={this.handleChange}
                    required
                  />
                  {s.errors.endDate && (
                    <span className="input-group-error">
                      {s.errors.endDate}
                    </span>
                  )}
                </div>
              </div>

               <div className="input-group">
                <label className="input-group-text">Details</label>
                <textarea
                  name="detail"
                  className={`form-control ${
                    s.errors.detail ? " !border-red-500" : ""
                  }`}
                  value={s.detail}
                  onChange={this.handleChange}
                  placeholder="Enter announcement detail"
                  rows="3"
                  required
                />
                {s.errors.detail && (
                  <span className="input-group-error">{s.errors.detail}</span>
                )}
              </div>
              <div className="row">
                <div className="col">
                  <div className="input-group">
                    <label className="input-group-text">Picture</label>
                    <input
                      name="pictureFile"
                      className="form-control"
                      type="file"
                      onChange={this.handleFileChange}
                      accept="image/*"
                    />
                    {s.errors.pictureFile && (
                      <span className="input-group-error">
                        {s.errors.pictureFile}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col"></div>
              </div>
            </form>
          </Modal>
        )}
        {s.readMore && (
          <Modal
            title="Announcement Details"
            closeAction={() => this.setState({ readMore: false })}
            footerContent={
              <>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() =>
                    this.setState({
                      readMore: false,
                      announcementId: undefined,
                      announcementDetail: {},
                    })
                  }
                >
                  Close
                </button>
              </>
            }
          >
            <div className="max-w-4xl mx-auto p-6">
              {/* Header Section */}
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-6 mb-6 border-l-4 border-blue-500">
                <h2 className="text-2xl font-bold text-gray-800 mb-2">
                  {s.announcementDetail.title || "Announcement Details"}
                </h2>
                <div className="flex flex-wrap gap-4 text-sm text-gray-600">
                  <div className="flex items-center gap-2">
                    <span className="font-medium">Created by:</span>
                    <span className="text-blue-600">
                      {s.announcementDetail.createdBy || "N/A"}
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="font-medium">Type:</span>
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-medium ${
                        s.announcementDetail.announcementType === "LOST"
                          ? "bg-red-100 text-red-800"
                          : s.announcementDetail.announcementType === "STOLEN"
                          ? "bg-orange-100 text-orange-800"
                          : s.announcementDetail.announcementType === "RECOVERED"
                          ? "bg-green-100 text-green-800"
                          : "bg-gray-100 text-gray-800"
                      }`}
                    >
                      {s.announcementDetail.announcementType || "N/A"}
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="font-medium">Asset Type:</span>
                    <span className="text-purple-600">
                      {s.announcementDetail.assetType || "N/A"}
                    </span>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Asset Information Card */}
                { s.announcementDetail.assetType &&
                <div className="bg-white rounded-lg shadow-md p-6 border border-gray-200">
                  <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                    <svg
                      className="w-5 h-5 text-blue-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      />
                    </svg>
                    Asset Information
                  </h3>
              
                  <div className="space-y-3">
                                                        <div className="flex justify-between items-start">
                                                          <span className="font-medium text-gray-600">
                                                            {primaryLabelName(s.announcementDetail.assetType)}:
                                                          </span>
                                                          <span className="text-gray-800 text-right">
                                                            {s.announcementDetail.uniqueIdentifier1 || "N/A"}
                                                          </span>
                                                        </div>
                                                        <div className="flex justify-between items-start">
                                                          <span className="font-medium text-gray-600">
                                                           {secondaryLabelName(s.announcementDetail.assetType)}:
                                                          </span>
                                                          <span className="text-gray-800 text-right">
                                                            {s.announcementDetail.uniqueIdentifier2 || "N/A"}
                                                          </span>
                                                        </div>
                                                        <div className="flex justify-between items-start">
                                                          <span className="font-medium text-gray-600">
                                                            {uniqueIdentifier1Name(s.announcementDetail.assetType)}:
                                                          </span>
                                                          <span className="text-gray-800 text-right font-mono text-sm bg-gray-50 px-2 py-1 rounded">
                                                            {s.announcementDetail.uniqueIdentifier1 || "N/A"}
                                                          </span>
                                                        </div>
                                                        {s.announcementDetail.assetType === 'MOBILE' &&
                                                        <div className="flex justify-between items-start">
                                                          <span className="font-medium text-gray-600">
                                                            {uniqueIdentifier2Name(s.announcementDetail.assetType)}:
                                                          </span>
                                                          <span className="text-gray-800 text-right font-mono text-sm bg-gray-50 px-2 py-1 rounded">
                                                            {s.announcementDetail.uniqueIdentifier2 || "N/A"}
                                                          </span>
                                                        </div> }
                                                      </div>
                                                    </div>
                                                }
                                  {/* Details Card */}
                                  <div className="bg-white rounded-lg shadow-md p-6 border border-gray-200">
                                    <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                                      <svg
                                        className="w-5 h-5 text-green-500"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth="2"
                                          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                        />
                                      </svg>
                                      Announcement Details
                                    </h3>
                  
                                    <div className="space-y-3">
                                      <div>
                                        <span className="font-medium text-gray-600 block mb-2">
                                          Description:
                                        </span>
                                        <div className="text-gray-800 bg-gray-50 p-3 rounded-md min-h-[80px]">
                                          {s.announcementDetail.detail ||
                                            "No description available"}
                                        </div>
                                      </div>
                  
                                      {s.announcementDetail.contentType && (
                                        <div>
                                          <span className="font-medium text-gray-600 block mb-2">
                                            Image:
                                          </span>
                                          <div className="bg-gray-50 p-3 rounded-md">
                                             { s.announcementDetail.contentType === 'application/pdf' && <iframe title="File View" src={s.announcementDetail.fileData} type="application/pdf" style={{ width: 100 + '%', height: 500 + 'px' }}></iframe> }
                                             { s.announcementDetail.contentType.includes('image') && <img title="File View" alt={s.announcementDetail.contentType} src={'data:'+s.announcementDetail.contentType+';base64,' + s.announcementDetail.fileData}  style={{ width: 100 + '%' }} /> }
                                            <div className="hidden text-gray-500 text-sm italic">
                                              Image not available or failed to load
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                
            </div>
          </Modal>
        )}
      </div>
    );
  }
}
